enum STORAGE_VARIABLE {
    IS_REMEMBER_ME = 'IS_REMEMBER_ME',
    AUTH = 'AUTH',
}

export type TKeyStorageVariable = STORAGE_VARIABLE;
export default STORAGE_VARIABLE;
